import {Component, Input, OnChanges, input, inject} from '@angular/core';
import {PredictionRotaWeek} from '../../../../classes/models/PredictionRotaWeek';
import moment from 'moment';
import {DataService} from '../../../../services/store/data.service';
import {Router} from '@angular/router';
import {asIsoWeekday, DayOfWeek, dayOfWeekValues} from '../../../../classes/enums/DayOfWeek';
import {RotaPageSwitchComponent} from "../../../../shared/components/rota-page-switch/rota-page-switch.component";
import {SHARED_IMPORTS} from "../../../../shared/standalone-imports";

@Component({
  selector: 'app-rota-week-select',
  templateUrl: './rota-week-select.component.html',
  styleUrls: ['./rota-week-select.component.less'],
  imports: [SHARED_IMPORTS, RotaPageSwitchComponent,

  ]
})
export class RotaWeekSelectComponent implements OnChanges {
  private dataService = inject(DataService);
  private router = inject(Router);


  /** An identifier of a week, for which a rota should be displayed. */
  @Input() weekId: string;
  /** `True` if links to other pages are enabled. */
  readonly showLinks = input<boolean>(undefined);

  /** A current week of rota and footfall predictions. */
  currentWeek: PredictionRotaWeek;
  /** A previous week of rota and footfall predictions. */
  previousWeek: PredictionRotaWeek;
  /** A next week of rota and footfall predictions. */
  nextWeek: PredictionRotaWeek;
  /** Each day of the week. */
  weekdays: DayOfWeek[] = dayOfWeekValues();

  /**
   * Assigns previous, current and next week on any input changes.
   */
  ngOnChanges(): void {
    this.currentWeek = this.getRotaWeek(this.weekId);
    this.assignPreviousRotaWeek();
    this.assignNextRotaWeek();
  }

  /**
   * Goes to the given date's rota page.
   * @param dayOfWeek the day of week of the rota.
   */
  navigateToDay(dayOfWeek: DayOfWeek) {
    const isoWeekday = asIsoWeekday(dayOfWeek);
    const date = moment(this.currentWeek.from).isoWeekday(isoWeekday).format('YYYY-MM-DD');
    if (this.showLinks()) {
      this.router.navigate(['rota-day', date]);
    }
  }

  private getRotaWeek(id): PredictionRotaWeek {
    if (!this.dataService.predictionRotaWeeks) {
      return;
    }
    return this.dataService.predictionRotaWeeks
            .filter(week => week.rotaExist)
            .find(week => week.id === id);
  }

  private assignPreviousRotaWeek(): void {
    const weekId = moment(this.currentWeek.from).add(-1, 'weeks').format(PredictionRotaWeek.WEEK_FORMAT);
    this.previousWeek = this.getRotaWeek(weekId);
  }

  private assignNextRotaWeek(): void {
    const weekId = moment(this.currentWeek.to).add(1, 'weeks').format(PredictionRotaWeek.WEEK_FORMAT);
    this.nextWeek = this.getRotaWeek(weekId);
  }
}
